import React, { useContext , useEffect } from 'react';
import {useNavigate, Link } from 'react-router-dom';
import { useLocation, matchPath } from "react-router-dom";

import { AuthContext } from '../AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faSignOut, faWallet } from '@fortawesome/free-solid-svg-icons'; // Пример иконок из FontAwesome
import s from '../styles/Navbar.module.css'; // Подключение стилей
import Avatar from './Avatar'; // путь к файлу компонента




function Navbar() {
  const { currentUser, loading} = useContext(AuthContext); // Получаем текущее состояние пользователя 
  const location = useLocation();

  const showBackButton =    
    location.pathname.startsWith("/Menu") ||
    location.pathname.startsWith("/add") ||
    location.pathname.startsWith("/complect");

  const homelocation = location.pathname === "/";


  const navigate = useNavigate();
  
  useEffect(() => {
    if (loading) return;
  
    const isOnQrCodePage = location.pathname === "/qrcode";
    const isOnLogOutPage = location.pathname === "/logout";
    const isOnSuccessPage = location.pathname === "/success";
    const isOnResetPasswordPage = location.pathname === "/reset-password";
    const { tgsecretkey, tg_user_id } = currentUser || {};
  
    // Если пользователь авторизован, есть tgsecretkey, но еще нет tg_user_id — показать qrcode
    if (currentUser && tgsecretkey && !tg_user_id && !isOnQrCodePage && !isOnLogOutPage) {
      console.log('navbar to qr');
      navigate("/qrcode");
    }
  
    // Если пользователь не авторизован — вернуть на главную
    else if (!currentUser && location.pathname !== "/" && !isOnLogOutPage && !isOnSuccessPage && !isOnResetPasswordPage) {
      console.log('navbar to /');
      navigate("/");
    }
  }, [currentUser, loading, navigate, location.pathname]);
  
  const handleAvatarClick = () => {
    navigate("/Menu");
  };

  const handleWalletClick = () => {
  navigate("/dashboard?tab=payments");
  };
  
  return (
    <nav className={currentUser? s.navbar : s.invisible}>
        <div className={s.container}>
         
        {homelocation ? (
            <a href="https://admin.pulseads.ru/" target="_blank" rel="noopener noreferrer">
              <img className={s.logo} src="/logo_admin_pulseads.svg" alt="Логотип" />
            </a>
          ) : (
            <Link to="/">
              <img className={s.logo} src="/logo_admin_pulseads.svg" alt="Логотип" />
            </Link>
          )}
          <Link to="/dashboard" className={showBackButton  ? s.backButton : s.hidden}>← Назад к списку</Link> 

            </div>
      {/* Правая часть с иконками */}
      
        {currentUser ? (
          <>
          <div className={s.balance_menu_all_div}>
              <div onClick={handleWalletClick} className={s.balance_days_div}>
                  <div className={s.balance_div}>
                  <FontAwesomeIcon icon={faWallet} className={s.faWallet}/>
                  {currentUser.balance}р.
                  </div>
                  <div className={`${s.days_div} ${currentUser.days_remaining < 3 ? s.days_div_red : ''}`}>
                      <p className={s.tarif_name}>
                      {currentUser.tarif_name}
                      </p>
                      на
                      <p className={s.days_p}>
                        {currentUser.days_remaining}
                      </p>
                      <p className={s.days_div_p}>дн.</p>
                    </div>

              </div>
              <div  onClick={handleAvatarClick} className={s.navbar_links}>
                  {/* Отображаем иконки для авторизованного пользователя */}
                  <Avatar userId={currentUser.id} />          
              </div>
          </div>
          
          </>
        ) : currentUser ? (
          <>
            {/* Отображаем иконки для неавторизованного пользователя */}
            
            <li>
              <Link to="/logout" title="Logout">
              <FontAwesomeIcon icon={faSignOut} />
              </Link>
            </li>
          </>
          ) : (
          <>
           
          </>
        )}
     
    </nav>
  );
};

const styles = {
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    cursor: "pointer",
    border: "none",
    borderRadius: "5px",
    background: "#007bff",
    color: "white",
  }
};

export default Navbar;
